import { uniqueId } from 'lodash-es';
import { TUploaderFileInfo } from '../../../../common/uploader/types';
import UploaderListElement from './UploaderListElement';

export interface IApiaUploaderList {
  autoFocus?: boolean;
  forGrid: boolean;
  fontColor?: string;
  id?: string;
  isDisabled?: boolean;
  isReadonly?: boolean;
  noDownload?: boolean;
  noErase?: boolean;
  noLock?: boolean;
  noModify?: boolean;
  noSign?: boolean;
  noUpload?: boolean;
  noVersion?: boolean;
  noVerifySign?: boolean;
  onCheckSignature?: (fileObj: TUploaderFileInfo) => unknown;
  onDownloadFile: (fileObj: TUploaderFileInfo) => unknown;
  onDrop: (fileObj: TUploaderFileInfo, newFile: File) => unknown;
  onEditFile: (fileObj: TUploaderFileInfo) => unknown;
  onLockFile: (fileObj: TUploaderFileInfo) => unknown;
  onOneClickUpload?: (fileObj?: TUploaderFileInfo) => unknown;
  onRemoveFile: (fileObj: TUploaderFileInfo) => unknown;
  onTranslateFile?: (fileObj: TUploaderFileInfo) => unknown;
  onSignFile?: (fileObj: TUploaderFileInfo) => unknown;
  onVersion?: (fileObj: TUploaderFileInfo) => unknown;
  progress?: Record<TUploaderFileInfo['docId'], number>;
  uploadedList: TUploaderFileInfo[];
}

const ApiaUploaderList = ({
  id = uniqueId(),
  uploadedList,
  ...props
}: IApiaUploaderList): JSX.Element => {
  return (
    <ul
      data-testid="file-uploader-list"
      className="uploaderFilesList"
      sx={{
        display: uploadedList?.length > 0 ? 'block' : 'none',
      }}
    >
      {uploadedList?.map((file) => {
        return (
          <UploaderListElement
            key={`${file.docId}${file.name || file.docName || ''}`}
            {...props}
            file={file}
            progress={(props.progress ?? {})[file.docId]}
            id={id}
          />
        );
      })}
    </ul>
  );
};

export default ApiaUploaderList;
